import * as actionType from 'constants/action-constants';
import {
  GET_PROPERTY_DETAILS_FAILURE,
  GET_PROPERTY_DETAILS_REQUEST,
  GET_PROPERTY_DETAILS_SUCCESS,
} from 'actions/get-property-detail-action';

import {
  GET_AUGMENTED_GUESTROOMS_FAILURE,
  GET_AUGMENTED_GUESTROOMS_REQUEST,
  GET_AUGMENTED_GUESTROOMS_SUCCESS,
} from 'actions/get-augmented-guestrooms-action';

import {
  GET_BOOKING_GUESTROOM_NAME_FAILURE,
  GET_BOOKING_GUESTROOM_NAME_REQUEST,
  GET_BOOKING_GUESTROOM_NAME_SUCCESS,
} from 'actions/get-booking-guest-room-name-action';

export const RESET_PROPERTY = 'RESET_PROPERTY';

export const resetProperty = () => ({ type: RESET_PROPERTY });

const initialState = {
  error: '',
  errorCode: null,
  isLoading: false,
  imageConfig: null,
  batchId: null,
  mainProperties: null,
  properties: null,
  roomImages: null,
  miscRoomImages: null,
  mainMiscRoomImages: null,
  mainRoomImages: null,
  currentUploadedImage: [],
  roomList: [],
  roomCount: 0,
  propertyCount: 0,
  contentPublishStatus: null,
  imageUploadStatus: null,
  batchStatus: null,
  imageTags: [],
  previewOnSaveAndPublish: null,
  contentPublish: null,
  isGetUploadImagesLoading: false,
  propertyDetail: null,
  currency: null,
  brands: null,
  languages: null,
  states: null,
  countries: null,
  otaCodes: null,
  timeZones: null,
  isImageDeleteLoading: false,
  isOriginalSetLoading: false,
  isImageSetTagsCaptionLoading: false,
  isAutoenhanceLoading: false,
  isImageSearch: false,
  isImageFilter: false,
  isImageSetCoverimage: false,
  isImageSetEditFilter: false,
  isBatchIdLoading: false,
  isPropertyUpdating: false,
  isgetPropertyLoading: false,
  getPropertyStatus: null,
  isImageTagsLoading: false,
  isImageUploading: false,
  isImageUploadStatus: false,
  isRoomLoading: false,
  isRoomImagesLoading: false,
  isImageAssignLoading: false,
  isRoomImagesDeleteLoading: false,
  isBatchStatusLoading: false,
  isUpdateImageScoreLoading: false,
  isAutoenhanceImageStatusLoading: false,
  isMoveToPropertyImagesLoading: false,
  propertyUpdateStatus: '',
  wizardStatus: '',
  wizardList: null,
};
/**
 *
 * @param {*} state - The Intial state
 * @param {*} action - The action object containing action type and payload
 * @returns - Updated state object
 */
const propertyReducer = (state = initialState, action) => {
  /*
        This reducer function makes changes in the redux state 
        based on the actions
    */

  switch (action.type) {
    // Reset error case.
    case actionType.RESET_ERROR:
      return {
        ...state,
        error: '',
        errorCode: null,
      };

    // Reset images case.
    case actionType.RESET_IMAGES:
      return {
        ...state,
        properties: [],
        roomImages: [],
        miscRoomImages: [],
        mainProperties: [],
        mainRoomImages: [],
        mainMiscRoomImages: [],
        roomCount: 0,
        propertyCount: 0,
      };

    // Get image configuration cases.
    case actionType.GET_IMAGE_CONFIGURATION_REQUEST:
      return {
        ...state,
        isLoading: true,
        status: '',
        error: '',
        errorCode: null,
      };

    case actionType.GET_IMAGE_CONFIGURATION_SUCCESS:
      return {
        ...state,
        imageConfig: action.payload.data,
        isLoading: false,
        status: 'success',
      };

    case actionType.GET_IMAGE_CONFIGURATION_FAILURE:
      return {
        ...state,
        error: `${action.payload.code} - ${action.payload.message}`,
        errorCode: action.payload.code,
        isLoading: false,
        status: 'failure',
      };

    case actionType.GET_BATCH_ID_REQUEST:
      return {
        ...state,
        isBatchIdLoading: true,
        status: '',
        error: '',
        errorCode: null,
      };
    case actionType.GET_BATCH_ID_SUCCESS:
      return {
        ...state,
        batchId: action.payload?.data?.batchId,
        isBatchIdLoading: false,
        status: 'success',
      };
    case actionType.GET_BATCH_ID_FAILURE:
      return {
        ...state,
        error: `${action.payload.code} - ${action.payload.message}`,
        isBatchIdLoading: false,
        status: 'failure',
        errorCode: action.payload.code,
      };

    case actionType.IMAGE_RENDER:
      return {
        ...state,
        properties: [...action.payload, ...state.properties],
        mainProperties: [...action.payload, ...state.properties],
      };

    case actionType.BATCH_STATUS_REQUEST:
      return {
        ...state,
        isBatchStatusLoading: true,
        status: '',
        batchStatus: null,
        error: '',
        errorCode: null,
      };
    case actionType.BATCH_STATUS_SUCCESS: {
      return {
        ...state,
        batchStatus: action.payload?.batchStatus,
        isBatchStatusLoading: false,
        status: 'success',
      };
    }
    case actionType.BATCH_STATUS_FAILURE:
      return {
        ...state,
        error: `${action.payload.code} - ${action.payload.message}`,
        errorCode: action.payload.code,
        isBatchStatusLoading: false,
        status: 'failure',
      };

    // Getting property images cases.
    case actionType.GET_PROPERTY_IMAGES_REQUEST:
      return {
        ...state,
        isGetUploadImagesLoading: true,
        status: '',
        error: '',
        errorCode: null,
        batchStatus: null,
      };
    case actionType.GET_PROPERTY_IMAGES_SUCCESS: {
      return {
        ...state,
        isGetUploadImagesLoading: false,
        status: 'success',
        batchStatus: null,
        properties: action.payload.images || [],
        mainProperties: action.payload.filter
          ? state.mainProperties
          : action.payload.images || [],

        roomCount: action.payload.roomCount,
        propertyCount: action.payload.propertyCount,
      };
    }
    case actionType.GET_PROPERTY_IMAGES_FAILURE:
      return {
        ...state,
        isGetUploadImagesLoading: false,
        status: 'failure',
        error: `${action.payload.code} - ${action.payload.message}`,
        errorCode: action.payload.code,
        batchStatus: null,
      };

    case GET_PROPERTY_DETAILS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: '',
        status: '',
      };
    case GET_PROPERTY_DETAILS_SUCCESS:
      return {
        ...state,
        propertyDetail: action.payload,
        isLoading: false,
        status: 'success',
      };
    case GET_PROPERTY_DETAILS_FAILURE:
      return {
        ...state,
        error: `${action.payload.code} - ${action.payload.message}`,
        isLoading: false,
        status: 'failure',
      };

    // Delete images cases.
    case actionType.IMAGE_DELETE_REQUEST:
      return {
        ...state,
        status: '',
        error: '',
        errorCode: null,
        isImageDeleteLoading: true,
      };
    case actionType.IMAGE_DELETE_SUCCESS: {
      // Checking for cover image in deleteIdList
      const cover = [...state.properties, ...state.miscRoomImages].find(
        property =>
          action.payload.deleteIdList.some(
            id => id === String(property.imageId)
          ) && property.cover
      );

      const properties = state.properties.filter(
        property =>
          !action.payload.deleteIdList.some(
            id => id === String(property.imageId)
          )
      );

      const miscRoomImages = state.miscRoomImages.filter(
        image => !action.payload.deleteIdList.includes(String(image.imageId))
      );

      const roomImages = state.roomImages.reduce((accumalator, room) => {
        const images = room.images.filter(
          image =>
            !action.payload.deleteIdList.some(
              id => id === String(image.imageId)
            )
        );

        if (images.length) {
          accumalator.push({ ...room, images });
        }

        return accumalator;
      }, []);

      // Updating thumbnail in property subheader.
      const propertyDetail = {
        ...state.propertyDetail,
        prop: {
          ...state.propertyDetail.prop,
          information: {
            ...state.propertyDetail.prop.information,
            coverImage: cover
              ? ''
              : state.propertyDetail.prop.information.coverImage,
          },
        },
      };

      return {
        ...state,
        properties,
        mainProperties: properties,
        status: 'success',
        isImageDeleteLoading: false,
        miscRoomImages,
        mainMiscRoomImages: miscRoomImages,
        roomImages,
        mainRoomImages: roomImages,
        propertyDetail,
        propertyCount: action.payload.propertyCount,
        roomCount: action.payload.roomCount,
      };
    }
    case actionType.IMAGE_DELETE_FAILURE:
      return {
        ...state,
        isImageDeleteLoading: false,
        status: 'failure',
        error: `${action.payload.code} - ${action.payload.message}`,
        errorCode: action.payload.code,
      };

    //
    case actionType.GET_CURRENCY_REQUEST:
      return {
        ...state,
        isLoading: true,
        status: '',
        error: '',
        errorCode: null,
      };
    case actionType.GET_CURRENCY_SUCCESS:
      return {
        ...state,
        currency: action.payload?.data,
        isLoading: false,
        status: 'success',
      };
    case actionType.GET_CURRENCY_FAILURE:
      return {
        ...state,
        error: `${action.payload.code} - ${action.payload.message}`,
        errorCode: action.payload.code,
        isLoading: false,
        status: 'failure',
      };
    case actionType.GET_BRANDS_REQUEST:
      return {
        ...state,
        isLoading: true,
        status: '',
        error: '',
      };
    case actionType.GET_BRANDS_SUCCESS:
      return {
        ...state,
        brands: action.payload?.data,
        isLoading: false,
        status: 'success',
      };
    case actionType.GET_BRANDS_FAILURE:
      return {
        ...state,
        error: `${action.payload.code} - ${action.payload.message}`,
        isLoading: false,
        status: 'failure',
      };

    case actionType.GET_LANGUAGES_REQUEST:
      return {
        ...state,
        isLoading: true,
        status: '',
        error: '',
        errorCode: null,
      };
    case actionType.GET_LANGUAGES_SUCCESS:
      return {
        ...state,
        languages: action.payload?.data,
        isLoading: false,
        status: 'success',
      };
    case actionType.GET_LANGUAGES_FAILURE:
      return {
        ...state,
        error: `${action.payload.code} - ${action.payload.message}`,
        errorCode: action.payload.code,
        isLoading: false,
        status: 'failure',
      };

    case actionType.GET_TIMEZONE_REQUEST:
      return {
        ...state,
        isLoading: true,
        status: '',
        error: '',
        errorCode: null,
      };
    case actionType.GET_TIMEZONE_SUCCESS:
      return {
        ...state,
        timeZones: action.payload?.data,
        isLoading: false,
        status: 'success',
      };
    case actionType.GET_TIMEZONE_FAILURE:
      return {
        ...state,
        error: `${action.payload.code} - ${action.payload.message}`,
        errorCode: action.payload.code,
        isLoading: false,
        status: 'failure',
      };

    case actionType.GET_COUNTRY_REQUEST:
      return {
        ...state,
        isLoading: true,
        status: '',
        error: '',
        errorCode: null,
      };
    case actionType.GET_COUNTRY_SUCCESS:
      return {
        ...state,
        countries: action.payload?.data,
        isLoading: false,
        status: 'success',
      };
    case actionType.GET_COUNTRY_FAILURE:
      return {
        ...state,
        error: `${action.payload.code} - ${action.payload.message}`,
        errorCode: action.payload.code,
        isLoading: false,
        status: 'failure',
      };

    case actionType.GET_STATE_REQUEST:
      return {
        ...state,
        isLoading: true,
        status: '',
        error: '',
        errorCode: null,
      };
    case actionType.GET_STATE_SUCCESS:
      return {
        ...state,
        states: action.payload?.data,
        isLoading: false,
        status: 'success',
      };
    case actionType.GET_STATE_FAILURE:
      return {
        ...state,
        error: `${action.payload.code} - ${action.payload.message}`,
        errorCode: action.payload.code,
        isLoading: false,
        status: 'failure',
      };

    case actionType.GET_OTA_CODES_REQUEST:
      return {
        ...state,
        isLoading: true,
        status: '',
        error: '',
        errorCode: null,
      };
    case actionType.GET_OTA_CODES_SUCCESS:
      return {
        ...state,
        otaCodes: action.payload?.data,
        isLoading: false,
        status: 'success',
      };
    case actionType.GET_OTA_CODES_FAILURE:
      return {
        ...state,
        error: `${action.payload.code} - ${action.payload.message}`,
        errorCode: action.payload.code,
        isLoading: false,
        status: 'failure',
      };

    // Search image cases.
    case actionType.IMAGE_SEARCH_REQUEST:
      return {
        ...state,
        isImageSearch: true,
        status: '',
      };
    case actionType.IMAGE_SEARCH_SUCCESS:
      return {
        ...state,
        isImageSearch: false,
        status: action.payload.status,
        properties: action.payload.images,
      };
    case actionType.IMAGE_SEARCH_FAILURE:
      return {
        ...state,
        isImageSearch: false,
        status: 'failure',
        error: `${action.payload.code} - ${action.payload.message}`,
      };

    // Filter image cases.
    case actionType.IMAGE_FILTER_REQUEST:
      return {
        ...state,
        isImageFilter: true,
        status: '',
      };
    case actionType.IMAGE_FILTER_SUCCESS:
      return {
        ...state,
        isImageFilter: false,
        status: action.payload.status,
        properties: action.payload.images,
      };
    case actionType.IMAGE_FILTER_FAILURE:
      return {
        ...state,
        isImageFilter: false,
        status: 'failure',
        error: `${action.payload.code} - ${action.payload.message}`,
      };

    // // Set cover image cases.
    // case actionType.IMAGE_SET_COVERIMAGE_REQUEST:
    //   return {
    //     ...state,
    //     isImageSetCoverimage: true,
    //     status: '',
    //     error: '',
    //     errorCode: null,
    //   };
    // case actionType.IMAGE_SET_COVERIMAGE_SUCCESS: {
    //   let coverImage3;

    //   // Updating propperty images
    //   const [properties, coverImage1] = setCoverImage(
    //     state.properties,
    //     action.payload.imageId,
    //     action.payload.cover
    //   );

    //   // Updating misc room images
    //   const [miscRoomImages, coverImage2] = setCoverImage(
    //     state.miscRoomImages,
    //     action.payload.imageId,
    //     action.payload.cover
    //   );

    //   // Updating room images.
    //   const roomImages = state.roomImages.map(room => {
    //     const [images, coverImage] = setCoverImage(
    //       room.images,
    //       action.payload.imageId,
    //       action.payload.cover
    //     );

    //     if (coverImage) {
    //       coverImage3 = coverImage;
    //     }
    //     return { ...room, images };
    //   });

    //   // Updating thumbnail in property subheader.
    //   const propertyDetail = {
    //     ...state.propertyDetail,
    //     prop: {
    //       ...state.propertyDetail.prop,
    //       information: {
    //         ...state.propertyDetail.prop.information,
    //         coverImage: coverImage1 || coverImage2 || coverImage3,
    //       },
    //     },
    //   };

    //   return {
    //     ...state,
    //     isImageSetCoverimage: false,
    //     status: action.payload.status,
    //     properties,
    //     mainProperties: properties,
    //     roomImages,
    //     miscRoomImages,
    //     propertyDetail,
    //   };
    // }
    // case actionType.IMAGE_SET_COVERIMAGE_FAILURE:
    //   return {
    //     ...state,
    //     isImageSetCoverimage: false,
    //     status: 'failure',
    //     error: action.payload.message,
    //     errorCode: action.payload.code,
    //   };

    // Image edit filter cases.
    case actionType.IMAGE_SET_EDITFILTER_REQUEST:
      return {
        ...state,
        status: '',
        isImageSetEditFilterLoading: true,
        error: '',
        errorCode: null,
      };
    case actionType.IMAGE_SET_EDITFILTER_SUCCESS: {
      const properties = state.properties.map(property => {
        if (action.payload.imageId === property.imageId) {
          return {
            ...property,
            thumbnailUrl: action.payload.thumbUrl,
            editedUrl: action.payload.url,
            isOriginalSet: action.payload.isOriginalSet,
          };
        }

        return property;
      });

      const miscRoomImages = state.miscRoomImages.map(property => {
        if (action.payload.imageId === property.imageId) {
          return {
            ...property,
            thumbnailUrl: action.payload.thumbUrl,
            editedUrl: action.payload.url,
            isOriginalSet: action.payload.isOriginalSet,
          };
        }

        return property;
      });

      const roomImages = state.roomImages.map(room => {
        const images = room.images.map(image => {
          if (action.payload.imageId === image.imageId) {
            return {
              ...image,
              thumbnailUrl: action.payload.thumbUrl,
              editedUrl: action.payload.url,
              isOriginalSet: action.payload.isOriginalSet,
            };
          }

          return image;
        });

        return { ...room, images };
      });

      return {
        ...state,
        isImageSetEditFilterLoading: false,
        status: 'success',
        properties,
        mainProperties: properties,
        miscRoomImages,
        mainMiscRoomImages: miscRoomImages,
        roomImages,
        mainRoomImages: roomImages,
      };
    }
    case actionType.IMAGE_SET_EDITFILTER_FAILURE:
      return {
        ...state,
        isImageSetEditFilterLoading: false,
        status: 'failure',
        error: `${action.payload.code} - ${action.payload.message}`,
        errorCode: action.payload.code,
      };

    // Reset old property
    case RESET_PROPERTY:
      return {
        ...state,
        propertyDetail: null,
      };

    // Property update
    case actionType.UPDATE_PROPERTY_DETAILS_REQUEST:
      return {
        ...state,
        isPropertyUpdating: true,
        propertyUpdateStatus: '',
        error: '',
        errorCode: null,
      };
    case actionType.UPDATE_PROPERTY_DETAILS_SUCCESS:
      return {
        ...state,
        isPropertyUpdating: false,
        propertyUpdateStatus: 'propertyUpdateSuccess',
      };
    case actionType.UPDATE_PROPERTY_DETAILS_FAILURE:
      return {
        ...state,
        error:
          `${action.payload.code} - ${action.payload.message}` ||
          'Update Failed',
        errorCode: action.payload.code,
        isPropertyUpdating: false,
        status: 'failure',
      };

    // Image auto-enhance cases.
    case actionType.IMAGE_AUTOENHANCE_REQUEST:
      return {
        ...state,
        isAutoenhanceLoading: true,
        status: '',
        error: '',
        errorCode: null,
      };
    case actionType.IMAGE_AUTOENHANCE_SUCCESS: {
      const { url, isOriginalSet, thumbUrl, isImageAutoEnhanced } =
        action.payload;

      const properties = state.properties.map(property => {
        if (action.payload.imageId === property.imageId) {
          return {
            ...property,
            editedUrl: url,
            isOriginalSet,
            isImageAutoEnhanced,
            thumbUrl,
          };
        }

        return property;
      });

      const miscRoomImages = state.miscRoomImages.map(property => {
        if (action.payload.imageId === property.imageId) {
          return {
            ...property,
            editedUrl: action.payload.url,
            isOriginalSet: action.payload.isOriginalSet,
          };
        }

        return property;
      });

      const roomImages = state.roomImages.map(room => {
        const images = room.images.map(image => {
          if (action.payload.imageId === image.imageId) {
            return {
              ...image,
              editedUrl: action.payload.url,
              isOriginalSet: action.payload.isOriginalSet,
            };
          }

          return image;
        });

        return { ...room, images };
      });

      return {
        ...state,
        isAutoenhanceLoading: false,
        status: 'success',
        properties,
        mainProperties: properties,
        miscRoomImages,
        mainMiscRoomImages: miscRoomImages,
        roomImages,
        mainRoomImages: roomImages,
      };
    }
    case actionType.IMAGE_AUTOENHANCE_FAILURE:
      return {
        ...state,
        isAutoenhanceLoading: false,
        status: 'failure',
        error: `${action.payload.code} - ${action.payload.message}`,
        errorCode: action.payload.code,
      };

    // Image set tags and caption cases.
    case actionType.IMAGE_SET_TAGS_CAPTION_REQUEST:
      return {
        ...state,
        isImageSetTagsCaptionLoading: true,
        status: '',
        error: '',
        errorCode: null,
      };
    case actionType.IMAGE_SET_TAGS_CAPTION_SUCCESS: {
      const tags = [];

      // Formatting the tags.
      action.payload.tags.forEach(tag => {
        state.imageTags.forEach(t => {
          if (tag === t.id) {
            tags.push(t.tag);
          }
        });
      });

      const properties = state.properties.map(property => {
        if (action.payload.imageId === property.imageId) {
          return {
            ...property,
            caption: action.payload.caption,
            tags,
          };
        }

        return property;
      });

      const miscRoomImages = state.miscRoomImages.map(property => {
        if (action.payload.imageId === property.imageId) {
          return {
            ...property,
            caption: action.payload.caption,
            tags,
          };
        }

        return property;
      });

      const roomImages = state.roomImages.map(room => {
        const images = room.images.map(image => {
          if (action.payload.imageId === image.imageId) {
            return {
              ...image,
              caption: action.payload.caption,
              tags,
            };
          }

          return image;
        });

        return { ...room, images };
      });

      return {
        ...state,
        isImageSetTagsCaptionLoading: false,
        status: action.payload.status,
        properties,
        mainProperties: properties,
        miscRoomImages,
        mainMiscRoomImages: miscRoomImages,
        roomImages,
        mainRoomImages: roomImages,
      };
    }
    case actionType.IMAGE_SET_TAGS_CAPTION_FAILURE:
      return {
        ...state,
        isImageSetTagsCaptionLoading: false,
        status: 'failure',
        error: `${action.payload.code} - ${action.payload.message}`,
        errorCode: action.payload.code,
      };

    // Image tags list cases.
    case actionType.GET_IMAGE_TAGS_REQUEST:
      return {
        ...state,
        status: '',
        isImageTagsLoading: true,
        error: '',
        errorCode: null,
      };
    case actionType.GET_IMAGE_TAGS_SUCCESS:
      return {
        ...state,
        imageTags: action.payload,
        isImageTagsLoading: false,
        status: 'Success',
      };
    case actionType.GET_IMAGE_TAGS_FAILURE:
      return {
        ...state,
        status: 'failure',
        error: `${action.payload.code} - ${action.payload.message}`,
        errorCode: action.payload.code,
        isImageTagsLoading: false,
      };

    // Preview on save and publish.
    case actionType.GET_PREVIEW_ON_SAVE_AND_PUBLISH_REQUEST:
      return {
        ...state,
        error: '',
        errorCode: null,
        isLoading: true,
        status: '',
      };
    case actionType.GET_PREVIEW_ON_SAVE_AND_PUBLISH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: action.payload.status,
        previewOnSaveAndPublish: action.payload,
      };
    case actionType.GET_PREVIEW_ON_SAVE_AND_PUBLISH_FAILURE:
      return {
        ...state,
        isLoading: false,
        status: 'failure',
        error: `${action.payload.code} - ${action.payload.message}`,
        errorCode: action.payload.code,
      };

    // Publish content cases.
    case actionType.CONTENT_PUBLISH_REQUEST:
      return {
        ...state,
        status: '',
        error: '',
        errorCode: null,
        contentPublishStatus: null,
        isLoading: true,
      };
    case actionType.CONTENT_PUBLISH_SUCCESS:
      return {
        ...state,
        contentPublishStatus: action.payload,
        status: action.payload.status,
        isLoading: false,
      };
    case actionType.CONTENT_PUBLISH_FAILURE:
      return {
        ...state,
        status: 'failure',
        isLoading: false,
        error: `${action.payload.code} - ${action.payload.message}`,
        errorCode: action.payload.code,
      };

    // Image uploading cases.
    case actionType.IMAGE_UPLOAD_REQUEST:
      return {
        ...state,
        isImageUploading: true,
        error: '',
        errorCode: null,
        status: '',
      };
    case actionType.IMAGE_UPLOAD_SUCCESS:
      return {
        ...state,
        status: 'success',
        isImageUploading: false,
        currentUploadedImage:
          action.uploadImageNum === 0 ? [] : state.currentUploadedImage,
      };
    case actionType.IMAGE_UPLOAD_FAILURE:
      return {
        ...state,
        status: 'failure',
        isImageUploading: false,
        error: `${action.payload.code} - ${action.payload.message}`,
        errorCode: action.payload.code,
      };

    // Image upload status.
    case actionType.IMAGE_STATUS_REQUEST:
      return {
        ...state,
        error: '',
        errorCode: null,
        status: '',
        isImageUploadStatus: true,
      };
    case actionType.IMAGE_STATUS_SUCCESS: {
      let { properties, miscRoomImages, roomCount, propertyCount } = state;

      if (action.payload[0].level === 'Property') {
        properties = [...action.payload, ...state.properties];
        propertyCount = propertyCount + 1;
      } else {
        miscRoomImages = [...action.payload, ...state.miscRoomImages];
        roomCount = roomCount + 1;
      }

      return {
        ...state,
        status: 'success',
        isImageUploadStatus: false,
        imageUploadStatus: action.payload,
        currentUploadedImage: [
          ...state.currentUploadedImage,
          ...action.payload,
        ],
        properties,
        mainProperties: properties,
        miscRoomImages,
        mainMiscRoomImages: miscRoomImages,
        propertyCount,
        roomCount,
      };
    }
    case actionType.IMAGE_STATUS_FAILURE:
      return {
        ...state,
        status: 'failure',
        isImageUploadStatus: false,
        error: `${action.payload.code} - ${action.payload.message}`,
      };

    // Publish Status cases.
    case actionType.CONTENT_PUBLISH_STATUS_REQUEST:
      return {
        ...state,
        isLoading: true,
        contentPublishStatus: null,
        error: '',
        errorCode: '',
        status: '',
      };
    case actionType.CONTENT_PUBLISH_STATUS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        contentPublishStatus: action.payload,
        status: action.payload.status,
      };
    case actionType.CONTENT_PUBLISH_STATUS_FAILURE:
      return {
        ...state,
        isLoading: false,
        status: 'failure',
        error: `${action.payload.code} - ${action.payload.message}`,
        errorCode: action.payload.code,
      };

    case actionType.GET_WIZARD_DATA_REQUEST:
      return {
        ...state,
        isLoading: true,
        wizardStatus: '',
        error: '',
        errorCode: null,
      };
    case actionType.GET_WIZARD_DATA_SUCCESS:
      return {
        ...state,
        isLoading: false,
        wizardList: action.payload.data,
        wizardStatus: 'success',
      };
    case actionType.GET_WIZARD_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        wizardStatus: 'failure',
        error: `${action.payload.code} - ${action.payload.message}`,
        errorCode: action.payload.code,
      };

    // Get room cases
    case actionType.GET_ROOMS_REQUEST:
      return {
        ...state,
        error: '',
        errorCode: null,
        status: '',
        isRoomLoading: true,
      };
    case actionType.GET_ROOMS_SUCCESS:
      return {
        ...state,
        status: 'success',
        isRoomLoading: false,
        roomList: action.payload || [],
      };
    case actionType.GET_ROOMS_FAILURE:
      return {
        ...state,
        status: 'failure',
        isRoomLoading: false,
        error: `${action.payload.code} - ${action.payload.message}`,
        errorCode: action.payload.code,
      };

    // Get room images cases.
    case actionType.GET_ROOM_IMAGES_REQUEST:
      return {
        ...state,
        isRoomImagesLoading: true,
        error: '',
        errorCode: null,
        status: '',
      };
    case actionType.GET_ROOM_IMAGES_SUCCESS:
      return {
        ...state,
        isRoomImagesLoading: false,
        status: 'success',
        roomImages: action.payload.rooms || [],
        mainRoomImages: !action.payload.filter
          ? action.payload.rooms || []
          : state.mainRoomImages,
        miscRoomImages: action.payload.miscImages || [],
        mainMiscRoomImages: !action.payload.filter
          ? action.payload.miscImages || []
          : state.miscRoomImages,
        roomCount: action.payload.roomCount,
        propertyCount: action.payload.propertyCount,
      };
    case actionType.GET_ROOM_IMAGES_FAILURE:
      return {
        ...state,
        isRoomImagesLoading: false,
        status: 'failure',
        error: `${action.payload.code} - ${action.payload.message}`,
        errorCode: action.payload.code,
      };

    // // Image assign cases.
    // case actionType.IMAGE_ASSIGN_REQUEST:
    //   return {
    //     ...state,
    //     isImageAssignLoading: true,
    //     status: '',
    //     error: '',
    //     errorCode: null,
    //   };
    // case actionType.IMAGE_ASSIGN_SUCCESS: {
    //   const { imageIdList, roomIdList, tagIdList } = action.payload;
    //   let properties = state.properties,
    //     roomImages = state.roomImages,
    //     miscRoomImages = state.miscRoomImages,
    //     assignedRoomIdList = [];

    //   const tagNameList = filterTagNameFromId(state.imageTags, tagIdList);

    //   const newImageList = [
    //     ...miscRoomImages,
    //     ...properties,
    //     ...formatRoomImages(roomImages),
    //   ].reduce((accumalator, current) => {
    //     if (imageIdList.includes(current.imageId)) {
    //       accumalator.push({
    //         ...current,
    //         tags: [...current.tags, ...tagNameList],
    //       });
    //     }

    //     return accumalator;
    //   }, []);

    //   if (!roomIdList.length) {
    //     // Property Images.
    //     properties = properties.map(image => {
    //       const newImage = newImageList.find(
    //         img => img.imageId === image.imageId
    //       );

    //       if (newImage) {
    //         return newImage;
    //       }

    //       return image;
    //     });

    //     // Misc Images
    //     miscRoomImages = miscRoomImages.map(image => {
    //       const newImage = newImageList.find(
    //         img => img.imageId === image.imageId
    //       );

    //       if (newImage) {
    //         return newImage;
    //       }

    //       return image;
    //     });

    //     // Room Images.
    //     roomImages = roomImages.map(room => {
    //       const images = room.images.map(image => {
    //         const newImage = newImageList.find(
    //           img => img.imageId === image.imageId
    //         );

    //         if (newImage) {
    //           return newImage;
    //         }

    //         return image;
    //       });

    //       return { ...room, images };
    //     });
    //   } else {
    //     // Property Images.
    //     properties = properties.filter(image => {
    //       const newImage = newImageList.find(
    //         img => img.imageId === image.imageId
    //       );

    //       if (!newImage) {
    //         return image;
    //       }
    //     });

    //     // Misc Images
    //     miscRoomImages = miscRoomImages.filter(image => {
    //       const newImage = newImageList.find(
    //         img => img.imageId === image.imageId
    //       );

    //       if (!newImage) {
    //         return image;
    //       }
    //     });

    //     // Room Images.
    //     roomImages = roomImages.map(room => {
    //       if (roomIdList.includes(parseInt(room.id))) {
    //         let images = [];

    //         assignedRoomIdList.push(parseInt(room.id));

    //         // Handle the duplicates.
    //         newImageList.forEach(image => {
    //           if (!room.images.some(img => img.imageId === image.imageId)) {
    //             images.push(image);
    //           }
    //         });

    //         return {
    //           ...room,
    //           images: [...images, ...room.images],
    //         };
    //       }

    //       return room;
    //     });

    //     // Assigning images to the room which is currently having no images.
    //     const newRoomImages = roomIdList.reduce((accumalator, id) => {
    //       if (!assignedRoomIdList.includes(id)) {
    //         accumalator.push({
    //           id: String(id),
    //           images: newImageList,
    //         });
    //       }

    //       return accumalator;
    //     }, []);

    //     roomImages = [...newRoomImages, ...roomImages];
    //   }

    //   return {
    //     ...state,
    //     isImageAssignLoading: false,
    //     status: 'success',
    //     properties,
    //     mainProperties: properties,
    //     roomImages,
    //     mainRoomImages: roomImages,
    //     miscRoomImages,
    //     mainMiscRoomImages: miscRoomImages,
    //     propertyCount: action.payload.propertyCount,
    //     roomCount: action.payload.roomCount,
    //   };
    // }
    // case actionType.IMAGE_ASSIGN_FAILURE:
    //   return {
    //     ...state,
    //     isImageAssignLoading: false,
    //     error: action.payload.message,
    //     errorCode: action.payload.code,
    //     status: 'success',
    //   };

    // Room Images delete cases.
    case actionType.ROOM_IMAGES_DELETE_REQUEST:
      return {
        ...state,
        error: '',
        errorCode: null,
        status: '',
        isRoomImagesDeleteLoading: true,
      };
    case actionType.ROOM_IMAGES_DELETE_SUCCESS: {
      const { deleteIdList } = action.payload;
      let roomImages = [],
        deleteImageIdList = [],
        miscRoomImages = state.miscRoomImages,
        totalUniqueRoomImages = [];

      // Unique Room images.
      state.roomImages.forEach(room => {
        room.images.forEach(img => {
          if (
            !totalUniqueRoomImages.some(image => image.imageId === img.imageId)
          ) {
            totalUniqueRoomImages.push(img);
          }
        });
      });

      // Delete images from room
      state.roomImages.forEach(room => {
        let images = [];

        const deleteRoom = deleteIdList.filter(
          list => list.roomId === parseInt(room.id)
        );

        if (deleteRoom.length) {
          images = room.images.filter(
            image => !deleteRoom.some(list => list.imageId === image.imageId)
          );

          if (images.length > 0) {
            roomImages.push({ ...room, images });
          }
        } else {
          roomImages.push(room);
        }
      });

      // Getting unique images.
      deleteIdList.forEach(list => {
        if (!deleteImageIdList.includes(list.imageId)) {
          deleteImageIdList.push(list.imageId);
        }
      });

      // Looking for single image reference.
      deleteImageIdList.forEach(deleteImageId => {
        let flag = false;

        roomImages.forEach(room => {
          if (room.images.some(img => img.imageId === deleteImageId)) {
            flag = true;
            return;
          }
        });

        if (!flag) {
          const misc = totalUniqueRoomImages.find(
            img => img.imageId === deleteImageId
          );
          miscRoomImages = [...miscRoomImages, misc];
        }
      });

      return {
        ...state,
        status: 'success',
        isRoomImagesDeleteLoading: false,
        roomImages,
        mainRoomImages: roomImages,
        miscRoomImages,
        mainMiscRoomImages: miscRoomImages,
      };
    }
    case actionType.ROOM_IMAGES_DELETE_FAILURE:
      return {
        ...state,
        error: `${action.payload.code} - ${action.payload.message}`,
        errorCode: action.payload.code,
        status: 'failure',
        isRoomImagesDeleteLoading: false,
      };

    case actionType.CREATE_PROPERTY_DETAILS_REQUEST:
      return {
        ...state,
        isPropertyCreating: true,
        propertyCreateStatus: '',
        error: '',
        errorCode: null,
      };
    case actionType.CREATE_PROPERTY_DETAILS_SUCCESS:
      return {
        ...state,
        isPropertyCreating: false,
        propertyCreateStatus: 'propertyCreateSuccess',
      };
    case actionType.CREATE_PROPERTY_DETAILS_FAILURE:
      return {
        ...state,
        error:
          `${action.payload.code} - ${action.payload.message}` ||
          'Create Failed',
        errorCode: action.payload.code,
        isPropertyCreating: false,
        status: 'failure',
      };

    // Image toggle cases.
    case actionType.GET_IMAGE_TOGGLE_REQUEST:
      return {
        ...state,
        error: '',
        errorCode: null,
        status: '',
        isOriginalSetLoading: true,
      };
    case actionType.GET_IMAGE_TOGGLE_SUCCESS: {
      const { isOriginalSet, isImageAutoEnhanced } = action.payload;

      const properties = state.properties.map(property => {
        if (action.payload.imageId === property.imageId) {
          return {
            ...property,
            isOriginalSet,
            isImageAutoEnhanced,
          };
        }

        return property;
      });

      const miscRoomImages = state.miscRoomImages.map(property => {
        if (action.payload.imageId === property.imageId) {
          return {
            ...property,
            isOriginalSet: action.payload.isOriginalSet,
          };
        }

        return property;
      });

      const roomImages = state.roomImages.map(room => {
        const images = room.images.map(image => {
          if (action.payload.imageId === image.imageId) {
            return {
              ...image,
              isOriginalSet: action.payload.isOriginalSet,
            };
          }

          return image;
        });

        return { ...room, images };
      });

      return {
        ...state,
        status: 'success',
        isOriginalSetLoading: false,
        properties,
        mainProperties: properties,
        miscRoomImages,
        mainMiscRoomImages: miscRoomImages,
        roomImages,
        mainRoomImages: roomImages,
      };
    }
    case actionType.GET_IMAGE_TOGGLE_FAILURE:
      return {
        ...state,
        status: 'failure',
        error: `${action.payload.code} - ${action.payload.message}`,
        errorCode: action.payload.code,
        isOriginalSetLoading: false,
      };

    // Update image score action.
    case actionType.UPDATE_IMAGE_SCORE_REQUEST:
      return {
        ...state,
        isUpdateImageScoreLoading: true,
        error: '',
        status: '',
        errorCode: null,
      };
    case actionType.UPDATE_IMAGE_SCORE_SUCCESS: {
      // Update property details for image score.
      const propertyDetail = {
        ...state.propertyDetail,
        prop: {
          ...state.propertyDetail.prop,
          scoreSummary: {
            ...state.propertyDetail.prop.scoreSummary,
            images: action.payload.imageScore,
          },
        },
      };

      return {
        ...state,
        isUpdateImageScoreLoading: false,
        status: 'success',
        propertyDetail,
      };
    }
    case actionType.UPDATE_IMAGE_SCORE_FAILURE:
      return {
        ...state,
        isUpdateImageScoreLoading: false,
        error: `${action.payload.code} - ${action.payload.message}`,
        status: 'failure',
        errorCode: action.payload.code,
      };

    // Update image quality cases.
    case actionType.GET_AUTOENHANCE_IMAGE_STATUS_REQUEST:
      return {
        ...state,
        isAutoenhanceImageStatusLoading: true,
        error: '',
        status: '',
        errorCode: null,
      };

    case actionType.GET_AUTOENHANCE_IMAGE_STATUS_SUCCESS: {
      const properties = state.properties.map(property => {
        if (action.payload.imageId === property.imageId) {
          return {
            ...property,
            quality: action.payload.quality,
          };
        }

        return property;
      });

      const miscRoomImages = state.miscRoomImages.map(property => {
        if (action.payload.imageId === property.imageId) {
          return {
            ...property,
            quality: action.payload.quality,
          };
        }

        return property;
      });

      const roomImages = state.roomImages.map(room => {
        const images = room.images.map(image => {
          if (action.payload.imageId === image.imageId) {
            return {
              ...image,
              quality: action.payload.quality,
            };
          }

          return image;
        });

        return { ...room, images };
      });

      return {
        ...state,
        isAutoenhanceImageStatusLoading: false,
        status: 'success',
        properties,
        mainProperties: properties,
        miscRoomImages,
        mainMiscRoomImages: miscRoomImages,
        roomImages,
        mainRoomImages: roomImages,
      };
    }
    case actionType.GET_AUTOENHANCE_IMAGE_STATUS_FAILURE:
      return {
        ...state,
        isAutoenhanceImageStatusLoading: false,
        error: `${action.payload.code} - ${action.payload.message}`,
        status: 'failure',
        errorCode: action.payload.code,
      };

    // // Move to property images cases.
    // case actionType.MOVE_TO_PROPERTY_IMAGES_REQUEST:
    //   return {
    //     ...state,
    //     isMoveToPropertyImagesLoading: true,
    //     error: '',
    //     status: '',
    //     errorCode: null,
    //   };
    // case actionType.MOVE_TO_PROPERTY_IMAGES_SUCCESS: {
    //   const { imageIdList, tagIdList, propertyCount, roomCount } =
    //     action.payload;
    //   let { roomImages, miscRoomImages } = state;

    //   let imageList = [...miscRoomImages, ...formatRoomImages(roomImages)],
    //     tagNameList = [];

    //   if (tagIdList.length > 0) {
    //     tagNameList = filterTagNameFromId(state.imageTags, tagIdList);
    //   }

    //   const newImageList = imageList.reduce((accumalator, current) => {
    //     if (imageIdList.includes(current.imageId)) {
    //       accumalator.push({
    //         ...current,
    //         tags: [...current.tags, ...tagNameList],
    //       });
    //     }

    //     return accumalator;
    //   }, []);

    //   const properties = [...newImageList, ...state.properties];

    //   // If image is in misc
    //   miscRoomImages = miscRoomImages.filter(
    //     img => !imageIdList.includes(img.imageId)
    //   );

    //   // If images is in the room
    //   roomImages = roomImages.reduce((acc, room) => {
    //     const images = room.images.filter(
    //       img => !imageIdList.includes(img.imageId)
    //     );

    //     // After moving if there is still images in that room.
    //     if (images.length > 0) {
    //       acc.push({ ...room, images });
    //     }

    //     return acc;
    //   }, []);

    //   return {
    //     ...state,
    //     roomImages,
    //     mainRoomImages: roomImages,
    //     properties,
    //     mainProperties: properties,
    //     miscRoomImages,
    //     mainMiscRoomImages: miscRoomImages,
    //     roomCount,
    //     propertyCount,
    //     isMoveToPropertyImagesLoading: false,
    //   };
    // }
    // Get booking guestroom name case.
    case GET_BOOKING_GUESTROOM_NAME_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: '',
        status: '',
        errorCode: null,
      };
    case GET_BOOKING_GUESTROOM_NAME_SUCCESS: {
      const { name, index, roomTypeId, roomViewId, roomNameId } =
        action.payload;

      const { guestRooms } = state.propertyDetail.prop;

      guestRooms[index].information = {
        ...guestRooms[index].information,
        name,
        roomTypeId,
        roomView: roomViewId,
        roomNameId,
      };

      return {
        ...state,
        isLoading: false,
        status: 'success',
        propertyDetail: {
          ...state.propertyDetail,
          prop: {
            ...state.propertyDetail.prop,
            guestRooms,
          },
        },
      };
    }
    case GET_BOOKING_GUESTROOM_NAME_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: `${action.payload.code} - ${action.payload.message}`,
        status: 'failure',
      };

    case 'GET_AUGMENTED_GUESTROOMS_REQUEST':
      return {
        ...state,
        isLoading: true,
        error: '',
        status: '',
      };
    case 'GET_AUGMENTED_GUESTROOMS_SUCCESS':
      return {
        ...state,
        isLoading: false,
        status: 'success',
        propertyDetail: {
          ...state.propertyDetail,
          augmentedGuestrooms: action.payload,
        },
      };
    case 'GET_AUGMENTED_GUESTROOMS_FAILURE':
      return {
        ...state,
        error: `${action.payload.code} - ${action.payload.message}`,
        isLoading: false,
        status: 'failure',
      };

    default:
      return state;
  }
};

export default propertyReducer;
